import classNames from 'classnames'
import { useState } from 'react'
import styles from './_labModal.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { ReactSVG } from 'react-svg'

interface LabModalProps {
  onClose?: () => void
  children?: React.ReactNode
  overlayStyle?: string
  contentContainerStyle?: string
  customCloseStyle?: string
  isCloseButtonHidden?: boolean
}
const LabModal: React.FC<LabModalProps> = ({
  onClose,
  children,
  overlayStyle,
  contentContainerStyle,
  customCloseStyle,
  isCloseButtonHidden
}) => {
  const [isClosing, setIsClosing] = useState(false)

  const closeHandler = () => {
    setIsClosing(true)
    setTimeout(() => {
      onClose?.()
    }, 150)
  }

  const handleWrapperClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeHandler()
    }
  }

  return (
    <div className={styles.modalWrapper} onClick={handleWrapperClick}>
      <div
        className={classNames(
          styles.overlay,
          {
            [classNames(styles.close, customCloseStyle)]: isClosing
          },
          overlayStyle
        )}
        onClick={(event) => event.stopPropagation()}
      >
        {!isCloseButtonHidden && (
          <div className={styles.closeButtonContainer}>
            <button
              className={styles.closeButton}
              type="button"
              onClick={closeHandler}
            >
              <FontAwesomeIcon
                icon={faTimes}
                color="white"
                className={classNames('is-hidden-mobile', styles.closeIcon)}
              />
              <ReactSVG
                wrapper="span"
                src="../../../images/lab/modal_close_mobile.svg"
                className="is-hidden-tablet"
              />
            </button>
          </div>
        )}
        <div
          className={classNames(
            styles.modalContentContainer,
            contentContainerStyle
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default LabModal
